<template>
  <div class="section-main__warp" style="margin-top: 0px;">
    <div class="electricity-emissions">
      <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
        @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        <template slot="menuLeft">
          <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-edit-outline" @click="handleUdp(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
        </template>
      </ioc-table>
      <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
        width="35%">
        <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
          <el-form-item label="区域电网名称" prop="areaPowerName">
            <el-input v-model="addForm.areaPowerName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="排放因子值" prop="emissionFactor">
            <el-input v-model="addForm.emissionFactor" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="覆盖省份" prop="provinces">
            <el-select v-model="addForm.provinces" multiple collapse-tags placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in provincesArr" :key="item.value" :label="item.label"
                :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年份" prop="powerYear">
            <el-date-picker v-model="addForm.powerYear" type="year" value-format="yyyy" placeholder="请选择" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="powerRemark">
            <el-input v-model="addForm.powerRemark" placeholder="请输入" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
          <el-button @click="addCancel('addForm')">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/electricityEmissions";
import utils from "@src/common/utils";
import { regionData } from 'element-china-area-data'
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        areaPowerName: [{ required: true, message: '请输入区域电网名称', trigger: ['blur', 'change'] }],
        emissionFactor: [{ required: true, message: '请输入排放因子值', trigger: ['blur', 'change'] }],
        provinces: [{ required: true, message: '请选择覆盖省份', trigger: ['blur', 'change'] }],
        powerYear: [{ required: true, message: '请选择年份', trigger: ['blur', 'change'] }],
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        powerId: null,
        areaPowerName: '',
        emissionFactor: '',
        provinces: '',
        powerYear: '',
        powerRemark: '',
      },
      // provincesArr: [{ 'label': '北京市', 'value': '北京市' }, { 'label': '天津市', 'value': '天津市' }]
      provincesArr: regionData
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        areaPowerName: this.searchForm.areaPowerName
      };
      this.$fetch(api.electricityEmissions.queryElectricityList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.addForm.powerId = null
      this.addForm.areaPowerName = ''
      this.addForm.emissionFactor = ''
      this.addForm.provinces = ''
      this.addForm.powerYear = ''
      this.addForm.powerRemark = ''
      this.addVisible = true;
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.powerId) {
            let params = {
              powerId: this.addForm.powerId,
              areaPowerName: this.addForm.areaPowerName,
              emissionFactor: this.addForm.emissionFactor,
              provinces: this.addForm.provinces.join(','),
              powerYear: this.addForm.powerYear,
              powerRemark: this.addForm.powerRemark
            }
            this.$fetch(api.electricityEmissions.updateElectricityList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              areaPowerName: this.addForm.areaPowerName,
              emissionFactor: this.addForm.emissionFactor,
              provinces: this.addForm.provinces.join(','),
              powerYear: this.addForm.powerYear,
              powerRemark: this.addForm.powerRemark
            }
            this.$fetch(api.electricityEmissions.addElectricityList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 修改
    handleUdp(row) {
      this.dialogTitle = '修改'
      this.addForm.powerId = row.powerId
      this.addForm.areaPowerName = row.areaPowerName
      this.addForm.emissionFactor = row.emissionFactor
      this.addForm.provinces = !row.provinces ? [] : row.provinces.split(',')
      this.addForm.powerYear = row.powerYear
      this.addForm.powerRemark = row.powerRemark
      this.addVisible = true;
    },
    // 删除
    handleDel(row) {
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/carbon/emission/power/del/' + row.powerId + '.json').then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.electricity-emissions {
  width: 100%;
  height: calc(100vh - 115px);
}
</style>